import { render, staticRenderFns } from "./CallWorkspace.vue?vue&type=template&id=d97def7e&scoped=true&"
import script from "./CallWorkspace.vue?vue&type=script&lang=js&"
export * from "./CallWorkspace.vue?vue&type=script&lang=js&"
import style0 from "./CallWorkspace.vue?vue&type=style&index=0&id=d97def7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d97def7e",
  null
  
)

export default component.exports